import React from "react";
import PropTypes from "prop-types";
import { Box, Grid, Typography } from "@mui/material";
import WizardCardAnswers from "../CardAnswers";

const CardQuestion = (props: any) => {
  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Box>
          <Typography align="center" variant={"h4"}>
            {props.diagStep.text}
          </Typography>
        </Box>
      </Grid>
      <Grid item xs={12}>
        <Typography align="center" variant={"h6"}>
          Did this fix your problem?
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <WizardCardAnswers options={props.diagStep.options} />
      </Grid>
    </Grid>
  );
};

CardQuestion.propTypes = {
  diagStep: PropTypes.any,
};

export default CardQuestion;
